import { User } from 'lucide-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getPatientOverviewOptions } from '@generated';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';
import { Loading } from '~/shared/Loading';

export function PatientHeader({ stayId }: { stayId: string }) {
	return (
		<SuspenseWrapper name="PatientHeader" fullScreen={false} key={stayId} fallback={<Loading />}>
			<PatientHeaderBody stayId={stayId} />
		</SuspenseWrapper>
	);
}

function PatientHeaderBody({ stayId }: { stayId: string }) {
	const { data: patientOverview } = useSuspenseQuery(getPatientOverviewOptions(stayId));
	return (
		<div className="flex shrink-0 items-center gap-4">
			<div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-100">
				<User size={15} className="text-primary-600" />
			</div>
			<div className="flex flex-col gap-1.5">
				<div className="flex items-center gap-2">
					<span className="text-base font-semibold leading-none">{`${patientOverview.lastName}, ${patientOverview.firstName} ${patientOverview.middleInitial}.`}</span>
					<span className="rounded bg-pistachioGreen px-1.5 py-0.5 text-[10px] font-semibold text-primary-700">
						{patientOverview.chartStatusLabel}
					</span>
				</div>
				<div className="flex items-center gap-2 text-xs leading-none text-gray-500">
					<span className="font-mono">{patientOverview.patientIdentifier}</span>
					<span className="h-3 w-px bg-gray-300" />
					<span>Ch 1 · Ep 1</span>
					<span className="h-3 w-px bg-gray-300" />
					<span>SOC {patientOverview.startOfCareDate.toLocaleDateString()}</span>
				</div>
			</div>
		</div>
	);
}
